

import { useMemo } from "react";
import { defaultStepPropertyTypeListEnum, questionTypeEnum } from "assets/constants";
import { findProperty } from "utils";

export function useOnlyActiveQuestions(allMainProperties, questions, activeStep, step, showAllQuestions, questionsWithNotValidAnswers, userData) {
    const numberOfQuestions = questions && Object.keys(questions).length;
    const numberOfNotValidAnswers = questionsWithNotValidAnswers && Object.keys(questionsWithNotValidAnswers).length;
    const { serviceType: serviceTypeKey, appointmentType: appointmentTypeKey, location: locationKey, services: servicesKey } = defaultStepPropertyTypeListEnum;

    const hasServiceTypeIdSelect = !!findProperty(allMainProperties, serviceTypeKey);
    const hasAppointmentTypeIdSelect = !!findProperty(allMainProperties, appointmentTypeKey);

    const isServiceTypeStep = hasServiceTypeIdSelect || hasAppointmentTypeIdSelect;
    const isLocationStep = !!findProperty(allMainProperties, locationKey);
    const isServicesStep = !!findProperty(allMainProperties, servicesKey);

    const hasServiceTypeId = !!userData?.serviceType?.id;
    const hasAppointmentTypeId = !!userData?.appointmentType?.id;

    const hasServiceTypeData = !!userData?.serviceType?.id || !!userData?.appointmentType?.id;
    const hasLocationData = !!userData?.location?.id
    const hasServicesData = !!userData?.service?.id

    return useMemo(() => {
        return allMainProperties.filter(({value: {isTurnOn}}) => (isTurnOn === undefined || isTurnOn))
        .map((obj) => {
            if (obj.type !== defaultStepPropertyTypeListEnum.question && obj.type !== questionTypeEnum.multiSelection && obj.type !== questionTypeEnum.freeText && obj.type !== questionTypeEnum.services) {return obj;}
            const {propertyId, value, type, visible } = obj;
            const { isMandatory, questionKey } = value.questionConfig;
            const { title, additionalText: additionalDescription, hintText, buttonClear, helperText, warningText, label, buttonSubmit} = value.question;
            const questionConfig = value.questionConfig
            const answersConfig = value.answersConfig
            const executeAfterProxyQuestion = value.executeAfterProxyQuestion
            const executeAfterInternalQuestion = value.executeAfterInternalQuestion
            const executeAfterProxyAnswer = value.executeAfterProxyAnswer
            const executeAfterInternalAnswer = value.executeAfterInternalAnswer
            const answers = answersConfig && value.answers.map((answer, index)=> {
                const { answerKey, order } = value.answersConfig[index];
                const { title, additionalText } = answer;
                return { answerKey, title, additionalDescription: additionalText, order, hintText }
            })

            return {propertyId, type, value: {
                questionKey,
                isMandatory,
                title,
                additionalDescription,
                answers,
                buttonSubmit,
                hintText,
                buttonClear,
                questionConfig,
                answersConfig,
                helperText,
                warningText,
                label,
                executeAfterProxyQuestion,
                executeAfterInternalQuestion,
                executeAfterProxyAnswer,
                executeAfterInternalAnswer
              }, visible}
        }).reduce((array, obj, index, arr)=> {
            if((obj.type === defaultStepPropertyTypeListEnum.question ||  obj.type === questionTypeEnum.multiSelection ||  obj.type === questionTypeEnum.freeText ) && !showAllQuestions ){
                const { isMandatory, questionKey } = obj.value;
                const { hasRegex, regex } = obj?.value?.questionConfig || {};

                const validInput = questions && hasRegex && !!regex?.length
                    ? new RegExp(regex).test(questions[questionKey])
                    : true;

                const hasNotValidAnswer = questionsWithNotValidAnswers && !!questionsWithNotValidAnswers[questionKey] ;
                const isValidQuestion = !userData?.not_valid_questions?.includes(questionKey);

                const dontShowThisQuestion = userData && userData['dont_show_question'] ? userData['dont_show_question']?.hasOwnProperty(questionKey) : false;

                if (dontShowThisQuestion) {
                    array.push(obj);
                    return array;
                }

                //#region hide any questions that are located after the required properties
                if (isServiceTypeStep && !hasServiceTypeData) {
                    const isAfterServiceTypeSelect = hasServiceTypeIdSelect && index > arr.findIndex((property) => property.type === defaultStepPropertyTypeListEnum.serviceType);
                    const isAfterAppointmentTypeSelect = hasAppointmentTypeIdSelect && index > arr.findIndex((property) => property.type === defaultStepPropertyTypeListEnum.appointmentType); 

                    if (
                        (isAfterServiceTypeSelect && !hasServiceTypeId && (!isAfterAppointmentTypeSelect || !hasAppointmentTypeId)) 
                        || 
                        (isAfterAppointmentTypeSelect && !hasAppointmentTypeId && (!isAfterServiceTypeSelect || !hasServiceTypeId))
                    ) {
                        arr.splice(index);
                        return array;
                    }
                } 

                if (isLocationStep && !hasLocationData) {
                    const isAfterLocationSelect = index > arr.findIndex((property) => property.type === defaultStepPropertyTypeListEnum.location);

                    if (isAfterLocationSelect) {
                        arr.splice(index);
                        return array;
                    }
                } 

                if (isServicesStep && !hasServicesData) {
                    const isAfterServiceSelect = index > arr.findIndex((property) => property.type === defaultStepPropertyTypeListEnum.services);

                    if (isAfterServiceSelect) {
                        arr.splice(index);
                        return array;
                    }
                } 
                //#endregion

                if ((isMandatory && (!questions || !(questionKey in questions) || (isMandatory && !validInput && !hasNotValidAnswer)) && !showAllQuestions && isValidQuestion))
                    arr.splice(index + 1);
            }
            array.push(obj);
            return array;
        }
    ,[])
}
        , [numberOfQuestions, activeStep, step, showAllQuestions, numberOfNotValidAnswers, userData['dont_show_question'], userData?.serviceType?.id, userData?.location?.id, userData?.service?.id])
}


